// extracted by mini-css-extract-plugin
export default {"container":"xQ-z","title":"yQ-z","link":"zQ-z"};